<app-header />
<main>
  <app-alert />
  <router-outlet />
</main>
<app-footer />
<app-cookie-consent />
